// 公司公证
import { i18n } from '@/common/utils/i18n'
import { get } from 'lodash-es'

export default (state) => {
  let register = get(state, 'currentContractorDetail.contractorInfo.docInfo.register', {})
  return {
    title: i18n.gettext('登记簿'),
    content: [
      {
        title: i18n.gettext('商户号'),
        label: register.id
      },
      {
        title: i18n.gettext('登记簿照片'),
        content: i18n.gettext('查看'),
        isLink: true,
        arrow: true,
        pics: register.licensePics
      }
    ]
  }
}
